export const QUERY_CONFIG = {
  STALE_TIME: 1000 * 60 * 60 * 24, // 24 hours
} as const;
